export default __webpack_public_path__ + "static/media/0_Intro.8d32e78d.mp4";